import { X } from "lucide-react";
import { FC } from "react";
import { CreateInventoryForm } from "./create-inventory-form";

interface CreateInventorySidebarProps {
  open: boolean;
  onClose: () => void;
}

export const CreateInventorySidebar: FC<CreateInventorySidebarProps> = ({
  open,
  onClose,
}) => {
  const handleSuccess = () => {
    onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed right-0 top-0 h-full bg-[#fffff5] border-l-2 border-black z-50 overflow-y-auto w-full sm:w-[600px]">
      <div className="sticky top-0 bg-[#fffff5] border-b-2 border-black p-4 flex items-center justify-between z-10">
        <div className="border-2 border-black inline-block px-3 py-1">
          <h2 className="font-bold text-sm uppercase tracking-wide text-black !mb-0">
            Create Inventory
          </h2>
        </div>
        <button
          onClick={onClose}
          className="border-2 border-black bg-[#fffff5] text-black p-2 hover:bg-[#fffef5] transition-all"
          aria-label="Close"
        >
          <X size={20} />
        </button>
      </div>
      <div className="p-4">
        <CreateInventoryForm onSuccess={handleSuccess} onCancel={onClose} />
      </div>
    </div>
  );
};

